import { useRef, useState } from 'react'
import api from '../utils/api'
import { buildWalletStatementData, validateStatementDates } from '../utils/walletStatementData'

export default function WalletStatementExportButton({ accountName, userId, startDate = '', endDate = '', disabled = false }) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const pending = useRef(false)

  const exportStatement = async () => {
    if (pending.current) return
    pending.current = true
    setError('')
    setBusy(true)
    try {
      validateStatementDates(startDate, endDate)
      const params = {}
      if (startDate) params.startDate = startDate
      if (endDate) params.endDate = endDate
      const endpoint = userId ? `/wallet/transactions/${encodeURIComponent(userId)}` : '/wallet/transactions'
      const { data } = await api.get(endpoint, { params })
      const statement = buildWalletStatementData(data, { accountName, startDate, endDate })
      const { createWalletStatementPdf } = await import('../utils/walletStatementPdf')
      const doc = createWalletStatementPdf(statement)
      const name = String(accountName || 'RecordLOGS').replace(/[^a-z0-9_-]+/gi, '_').slice(0, 70)
      await doc.save(`${name}_Wallet_Statement_${startDate || 'beginning'}_${endDate || 'present'}.pdf`, { returnPromise: true })
    } catch (err) {
      setError(err?.response ? 'Could not load the statement. Please try again.' : err?.message || 'Could not export the statement. Please try again.')
    } finally {
      pending.current = false
      setBusy(false)
    }
  }

  return (
    <div className="px-4 sm:px-6 py-3 border-b border-gray-200 bg-white flex-shrink-0">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-xs text-gray-600">Download a PDF for the selected dates.</p>
        <button type="button" onClick={exportStatement} disabled={disabled || busy}
          className="min-h-[44px] w-full sm:w-auto px-4 py-2 rounded-lg bg-emerald-700 text-white text-sm font-medium hover:bg-emerald-800 disabled:opacity-50 disabled:cursor-not-allowed">
          {busy ? 'Preparing PDF...' : 'Export PDF'}
        </button>
      </div>
      {error && <p role="alert" className="mt-2 text-sm text-red-700">{error}</p>}
    </div>
  )
}
